import "./ToastStopCharging.css";
import Button from "../button/Button";
import Modal from "../modal/Modal";

interface Props {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setErrorStopCharging: React.Dispatch<React.SetStateAction<string>>;
  allowButtonClosed: boolean;
  handleStopCharging: () => void;
  isLoading?: boolean;
  errorStopCharging?: string;
}

const ToastStopCharging: React.FC<Props> = ({isModalOpen, errorStopCharging, setErrorStopCharging, isLoading, setIsModalOpen, allowButtonClosed, handleStopCharging}) => {
  return (
    <>
      <Modal 
        title="Deseja finalizar recarga?"
        allowButtonClosed={allowButtonClosed}
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false)
          setErrorStopCharging('')
        }}
        textEnterButton="Finalizar"
        handleEnterButton={handleStopCharging}
        isLoadingEnterButton={isLoading}
      >
        <div className="toast-stop-charging-modal-container">
          <p className="toast-stop-charging-modal-text">
            Seu carro ainda não está com a carga completa.
          </p>
          {errorStopCharging && <p className="toast-stop-charging-modal-text-error">
            {errorStopCharging}
          </p>}
        </div>
      </Modal>
    </>
  );
};

export default ToastStopCharging;
